// Import 3rd-party dependencies
import { Component, OnInit } from '@angular/core';
import { User } from '@microsoft/microsoft-graph-types';
import { map, switchMap } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';

// Import project-specific dependencies
import { VIEW_USER_PROFILE_COMPONENT_CONSTS } from '@app/config/constants';
import { PeopleService } from '@app/services/people/people.service';
import { CalendarEventsService } from '@app/services/calendar-events/calendar-events.service';
import { UserProfileService } from '@app/services/user-profile/user-profile.service';
import { ProfileLinksService } from '@app/services/profile-links/profile-links.service';

enum EUserInfoType {
  MANAGER = 'manager',
  LOCATION = 'location',
  USER = 'user',
  PROFILES = 'profiles'
}

enum EWorkerType {
  EMP = 'Employee',
  SC = 'Contingent'
}

@Component({
  selector: 'app-view-user-profile',
  templateUrl: './view-user-profile.component.html',
  styleUrls: ['./view-user-profile.component.css']
})
export class ViewUserProfileComponent implements OnInit {
  consts = VIEW_USER_PROFILE_COMPONENT_CONSTS;
  employeeDetails: User;
  managerDetails: User;
  ddProfile: { core_id: string; [key: string]: string };
  timezone: string;
  activeIndex: number;
  preferredName: string;

  employeeInformation$ = this.peopleService.currentUser$.subscribe((res) => {
    if (res) {
      this.preferredName = res.givenName.replace(
        this.consts.NAME_REGEX,
        (name: string, first: string, rest: string) => {
          return first.toUpperCase() + rest.toLowerCase();
        }
      );
      this.employeeDetails = res;
    }
  });

  managerInformation$ = this.peopleService.managerInfo$.subscribe((res) => {
    if (res) {
      this.managerDetails = res;
    }
  });

  calendarInformation$ = this.calendarService.getEmailSettings().subscribe((res) => {
    if (res) {
      this.timezone = res.timeZone;
    }
  });

  get workerType(): typeof EWorkerType {
    return EWorkerType;
  }
  //2296-TH-2295--disable_country_selection_for_UserProfile/MyProfiles/TrendingLink(ITconnect/UPtime)
  // Get the IT Support link of ITConnect or UPtime from the QuickLinks_json file
  /*
  profileLinks$ = combineLatest([this.peopleService.currentUser$, this.profileLinksService.profileLinks$]).pipe(
    switchMap(([user, links]) => {
      const country = user?.country || '';
      const idUPtime = links.findIndex((link) => link.title === this.consts.UPTIME);
      const idITConnect = links.findIndex((link) => link.title === this.consts.ITCONNECT);
      const removedLink = links[idUPtime].country.includes(country) ? idITConnect : idUPtime;
      return of(links.filter((link, index) => index !== removedLink));
    })
  );
  */
  profileLinks$ = this.profileLinksService.profileLinks$.pipe();

  constructor(
    private peopleService: PeopleService,
    private calendarService: CalendarEventsService,
    private profileService: UserProfileService,
    private profileLinksService: ProfileLinksService
  ) {
    this.activeIndex = 0;
  }

  ngOnInit(): void {
    this.peopleService.currentUser$
      .pipe(
        map((user) => user.employeeId),
        switchMap((employeeId) => this.profileService.getDdProfile(employeeId))
      )
      .subscribe((res) => {
        this.ddProfile = res;
      });
  }

  showInformation(type: string): void {
    switch (type) {
      case EUserInfoType.MANAGER:
        this.activeIndex = 1;
        break;
      case EUserInfoType.LOCATION:
        this.activeIndex = 2;
        break;
      case EUserInfoType.PROFILES:
        this.activeIndex = 3;
        break;
      case EUserInfoType.USER:
      default:
        this.activeIndex = 0;
        break;
    }
  }
}
